<template>
  <section class="app-main">
    <!-- 姓名邮箱。。 -->
    <el-card class="m-bottom-4">
      <el-row class="m-bottom-4">
        <el-col :span="1" class="input-left">姓名：</el-col>
        <el-col :span="5">
          <el-input v-model="name" placeholder="名"></el-input>
        </el-col>
      </el-row>
      <el-row class="m-bottom-4" gutter="3">
        <el-col :span="1" class="input-left">联系电话：</el-col>
        <el-col :span="1" class="input-leftadd">+</el-col>
        <el-col :span="2">
          <!-- <el-input v-model="area_code" placeholder="区号"></el-input> -->
          <el-select v-model="area_code" placeholder="区号选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input v-model="tel" placeholder="联系电话" type="tel"></el-input>
        </el-col>
      </el-row>
      <el-row class="m-bottom-4">
        <el-col :span="1" class="input-left">电子邮箱：</el-col>
        <el-col :span="5">
          <el-input v-model="email" placeholder="电子邮箱"></el-input>
        </el-col>
      </el-row>
    </el-card>
    <!-- 搜索添加列表 -->
    <el-card class="m-bottom-4" shadow="hover">
      <el-row class="m-bottom-4" :gutter="20">
        <el-col :span="6">
          <el-input
            v-model="searchVal"
            placeholder="请输入商品条形码"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="success" plain @click="search">点击确定</el-button>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model="searchGoodsVal"
            placeholder="请输入商品名称"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="success" plain @click="searchGoods">搜索</el-button>
        </el-col>
      </el-row>
      <!-- 列表 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        height="650"
        style="width: 100%"
      >
        <el-table-column align="center" label="图片">
          <template slot-scope="scope">
            <m-img v-if="scope.row.sku_pic" :src="scope.row.sku_pic" />
          </template>
        </el-table-column>
        <el-table-column
          prop="goods_name"
          align="center"
          label="名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="barcode"
          align="center"
          label="条形码"
        ></el-table-column>
        <el-table-column
          prop="sku_name"
          align="center"
          label="规格"
        ></el-table-column>
        <el-table-column
          prop="price"
          align="center"
          label="价格"
        ></el-table-column>
        <el-table-column align="center" label="数量">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.number"
              @change="handleChange(scope.row)"
              :min="0"
              size="small"
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination background @current-change="reloadData" :current-page.sync="page" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size" ></el-pagination> -->
    </el-card>
    <!-- 税金方式和性质 -->
    <el-card class="m-bottom-4">
      <el-row class="m-bottom-4"><div>② 购买性质（单选）</div></el-row>
      <el-row class="m-bottom-4">
        <el-radio-group v-model="nature">
          <el-radio :label="0">个人</el-radio>
          <el-radio :label="1">企业</el-radio>
        </el-radio-group>
      </el-row>
    </el-card>
    <!-- 优惠选择 -->
    <el-card class="m-bottom-4">
      <el-row class="m-bottom-4">是否优惠</el-row>
      <el-row class="m-bottom-4">
        <el-radio-group v-model="radio">
          <el-radio :label="0">是</el-radio>
          <el-radio v-model="discountNum" :label="3" @change="nodiscount"
            >否</el-radio
          >
        </el-radio-group>
      </el-row>

      <el-row class="m-bottom-4">
        <div v-if="radio == 0">
          <el-radio-group v-model="discountNum">
            <el-row class="m-bottom-4">
              <el-radio :label="1"
                >折扣
                <el-row v-if="discountNum == 1">
                  <el-col :span="14" style="margin: 10px 10px 0 0">
                    <el-input
                      v-model="percent"
                      @change="discountONe"
                    ></el-input>
                  </el-col>
                  <el-col :span="1" class="input-right">%</el-col>
                </el-row>
              </el-radio>
            </el-row>

            <el-row class="m-bottom-4">
              <el-radio :label="2"
                >优惠金额
                <el-row v-if="discountNum == 2">
                  <el-col :span="5" class="input-left">优惠金额：</el-col>
                  <el-col :span="14">
                    <el-input
                      v-model="discountInput"
                      @change="discountTwo"
                    ></el-input>
                    C$
                  </el-col>
                </el-row>
              </el-radio>
            </el-row>
          </el-radio-group>
        </div>
      </el-row>
    </el-card>
    <!-- 支付方式 -->
    <el-card class="m-bottom-4">
      <el-row class="m-bottom-4">选择支付方式</el-row>
      <el-row class="m-bottom-4">
        <el-radio-group v-model="pay_method">
          <el-radio :label="1">支付宝</el-radio>
          <el-radio :label="2">微信</el-radio>
          <el-radio :label="3">信用卡</el-radio>
          <el-radio :label="5">现金</el-radio>
          <el-radio :label="6">EMT</el-radio>
        </el-radio-group>
      </el-row>
      <el-row>
        <el-col :span="5"
          >商品金额： <span>{{ goods_amount.toFixed(2) }}</span
          >C$</el-col
        >
        <el-col :span="5"
          >订单总价： <span>{{ order_amount.toFixed(2) }}</span
          >C$</el-col
        >
        <el-col :span="5"
          >优惠金额： <span>{{ goods_discount_fee.toFixed(2) }}</span
          >C$</el-col
        >
        <el-col :span="5"
          >实付金额： <span>{{ order_total_amount.toFixed(2) }}</span
          >C$</el-col
        >
      </el-row>
    </el-card>
    <el-row class="m-bottom-4">
      <el-button type="success" plain style="width: 150px" @click="suborder"
        >提交订单</el-button
      >
    </el-row>
    <el-dialog title="商品列表" :visible.sync="goodsSearchDialog" width="1000px">
      <el-table :data="goodsSearchData">
        <el-table-column prop="date" label="商品图片" width="100">
          <template slot-scope="scope">
            <m-img v-if="scope.row.pic_image" :src="scope.row.pic_image.url" />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="商品名称"
   
        ></el-table-column>
        <el-table-column
          prop="attr_symbol_string"
          label="商品规格"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="barcode"
          label="商品条形码"
          width="150"
        ></el-table-column>
          <el-table-column
          prop="price"
          label="商品价格"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="stock"
          label="当前库存"
          width="100"
        ></el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="confirmGoods(scope.row.barcode)"
              >确定</el-button
            >
          </template>
        </el-table-column>
       
      </el-table>
        <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next, jumper"
        style="padding: 15px"
        :total="goodsSearchDataTotal"
        :page-size="goodsSearchDataSize"
      ></el-pagination>
    </el-dialog>
  </section>
</template>

<script>
import {
  orderGoodsAdd,
  orderGoodsDel,
  orderGoodsPrice,
  orderGoodsUpdate,
  orderGoodsList,
  orderGoodsPlace,
  storeOrderSearch,
} from "@/api/order.js";
import MImg from "./../../../components/Image";
export default {
  components: { MImg },
  data() {
    return {
      name: "",
      area_code: "1",
      tel: "",
      email: "",
      searchVal: "", // 条形码
      tableData: [], // 列表内容
      discountInput: "", // 优惠金额
      discountNum: 3, // 优惠方式
      nature: 0,
      radio: 3,
      discount: "",
      percent: "",
      pay_method: "",
      goods_amount: 0,
      order_amount: 0,
      goods_discount_fee: 0,
      order_total_amount: 0,
      options: [
        { value: 1, label: "1" },
        { value: 86, label: "86" },
      ],
      searchGoodsVal: "",
      goodsSearchDialog: false,
      goodsSearchData: [],
      goodsSearchDataPage: 1,
      goodsSearchDataTotal: 0,
      goodsSearchDataSize: 10,
    };
  },
  created() {
    this.getList();
    this.nodiscount();
  },
  methods: {
    search() {
      this.getData();
    },
    confirmGoods(barcode){
      this.searchVal = barcode;
       this.getData();
    },
    //搜索商品
    searchGoods() {
      this.getSearchGoods();
    },

    // 获取搜索结果
    getSearchGoods() {
      let params = {
        page: this.goodsSearchDataPage,
      };
      if (this.searchGoodsVal != "") {
        params.searchGoodsVal = this.searchGoodsVal;
      } else {
        return false;
      }

      this.goodsSearchData = [];
      storeOrderSearch(params).then((res) => {
        console.log(res);
        if (res) {
          this.goodsSearchData = res.data.data;
          this.goodsSearchDataTotal = res.data.total,
          this.goodsSearchDataSize = res.data.per_page,
          this.goodsSearchDialog = true;
        } else {
          this.goodsSearchData = [];
          this.goodsSearchDialog = true;
        }
      });
    },

    reloadData(page) {
      this.goodsSearchDataPage = page;
      this.getSearchGoods();
    },
    // 添加
    getData() {
      let params = {};
      if (this.searchVal != "") {
        params.barcode = this.searchVal;
      } else {
        return false;
      }
      orderGoodsAdd(params).then((res) => {
        console.log(res);
        this.getList();
        this.nodiscount();
        if(this.goodsSearchDialog){
          this.goodsSearchDialog = false;
        }
      });
    },
    // 获取列表
    getList() {
      this.tableData = [];
      orderGoodsList().then((res) => {
        console.log(res);
        if (res) {
          this.tableData = res.data;
        } else {
          this.tableData = [];
        }
      });
    },
    // 点击加减事件
    handleChange(row) {
      console.log(row.number);
      let params = {
        id: row.id,
        number: row.number,
      };
      orderGoodsUpdate(params).then((res) => {
        console.log(res);
        if (res.code == 20000) {
          this.nodiscount();
          if (row.number < 1) {
            // 删除商品
            let params = {
              ids: row.id,
            };
            console.log(params);
            orderGoodsDel(params).then((res) => {
              console.log(res);
              if (res) {
                this.getList();
              }
            });
          }
        }
      });
    },

    // 折扣
    discountONe(value) {
      console.log(value);
      let discount = (this.goods_amount * (value / 100)).toFixed(2);
      let params = {
        discountType: 1,
        discountAmount: discount,
        nature: this.nature,
      };
      orderGoodsPrice(params).then((res) => {
        if (res.code == 20000) {
          console.log(res);
          this.goods_discount_fee = res.data.goods_amount * (value / 100);
          this.goods_amount = res.data.goods_amount * 1;
          this.order_amount = res.data.order_amount * 1;
          this.order_total_amount = this.order_amount - this.goods_discount_fee;
        }
      });
    },
    // 直接优惠
    discountTwo(value) {
      let params = {
        discountType: 2,
        discountAmount: value,
        nature: this.nature,
      };
      orderGoodsPrice(params).then((res) => {
        if (res.code == 20000) {
          console.log(res);
          this.goods_discount_fee = value * 1;
          this.goods_amount = res.data.goods_amount * 1;
          this.order_amount = res.data.order_amount * 1;
          this.order_total_amount = this.order_amount - this.goods_discount_fee;
        }
      });
    },
    // 不优惠
    nodiscount() {
      let params = {
        discountType: 3,
        discountAmount: 0,
        nature: this.nature,
      };
      orderGoodsPrice(params).then((res) => {
        if (res) {
          console.log(res);
          this.goods_discount_fee = res.data.goods_amount * 0;
          this.goods_amount = res.data.goods_amount * 1;
          this.order_amount = res.data.order_amount * 1;
          this.order_total_amount = this.order_amount - this.goods_discount_fee;
        }
      });
    },
    // 提交
    suborder() {
      let params = {
        name: this.name,
        tel: this.tel,
        email: this.email,
        area_code: this.area_code,
        pay_method: this.pay_method,
        discountAmount: this.goods_discount_fee,
        discountType: this.discountNum,
        nature: this.nature,
      };
      orderGoodsPlace(params).then((res) => {
        if (res.code == 20000) {
          this.$message({ type: "success", message: res.msg });
          this.tableData = [];
          (this.goods_amount = 0),
            (this.order_amount = 0),
            (this.goods_discount_fee = 0),
            (this.order_total_amount = 0),
            (this.name = ""),
            (this.email = ""),
            (this.tel = ""),
            (this.percent = ""),
            (this.discountInput = 0),
            (this.searchVal = "");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.sizing {
  box-sizing: border-box;
}
section {
  .input-left {
    height: 40px;
    line-height: 40px;
    min-width: 90px;
  }
  .input-leftadd {
    height: 40px;
    line-height: 40px;
    text-align: center;
    width: 15px;
  }
  .input-right {
    height: 40px;
    line-height: 40px;
    min-width: 80px;
    margin-top: 10px;
  }
}
</style>